import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button } from '@hostfully/ui-components';
import FormFieldset from '@/components/forms/form/FormFieldset';
import InputField from '@/components/forms/InputField';
import useBackToLogin from '@/hooks/useBackToLogin';
import {
  PublicFormButtonContainer,
  PublicFormInputContainer,
} from '@/pages/_layouts/publicLayout/publicForm.styles';

interface RequestResetLinkFormProps {
  clearErrors: () => void;
  errorMessage?: string;
  isSubmitting: boolean;
}

const RequestResetLinkForm = ({
  clearErrors,
  errorMessage,
  isSubmitting,
}: RequestResetLinkFormProps) => {
  const { t } = useTranslation();
  const handleBackToLogin = useBackToLogin();
  const { email } = useWatch();

  useEffect(() => {
    clearErrors();
  }, [clearErrors, email]);

  return (
    <FormFieldset disabled={isSubmitting}>
      <PublicFormInputContainer>
        <InputField
          label={t('pageForgotPassword.email')}
          name="email"
          placeholder={t('pageForgotPassword.email')}
          type="email"
        />
      </PublicFormInputContainer>
      <PublicFormButtonContainer>
        <Button
          data-testid="back-to-login-button"
          variant="textPrimary"
          onClick={handleBackToLogin}
          disabled={isSubmitting}
        >
          {t('pageForgotPassword.backToLogin')}
        </Button>
        <Button
          data-testid="submit-button"
          disabled={!!errorMessage || isSubmitting}
          size="large"
          type="submit"
        >
          {t('pageForgotPassword.getResetLink')}
        </Button>
      </PublicFormButtonContainer>
      {!!errorMessage && (
        <p className="error-message" data-testid="error-message">
          {errorMessage}
        </p>
      )}
    </FormFieldset>
  );
};

export default RequestResetLinkForm;
